<template>
    <m-main-layout>
        <el-button size="small" type="primary" slot="right-btn" @click="$router.push({path:'/user/vip/price/list',query:{vip_id:formData.vip_id}})">返回列表</el-button>
        <div class="page-content-main">
            <el-form :model="formData" status-icon :rules="rules" ref="form" label-width="auto" class="margin-top" style="width:600px;">
                <el-form-item label="标题" prop="title">
                    <el-input v-model="formData.title" maxlength="20" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="唯一标示值" prop="price_level">
                    <el-input v-model.trim="formData.price_level" maxlength="20" show-word-limit style="width:300px;"></el-input>
                </el-form-item>
                <el-form-item label="时长" prop="to_time">
                    <el-input placeholder="请输入内容" v-model.trim="formData.to_time" class="input-with-select" style="width:300px;">
                        <el-form-item prop="time_type" slot="append">
                            <el-select v-model="formData.time_type" placeholder="请选择">
                                <el-option label="天" value="day"></el-option>
                                <el-option label="周" value="week"></el-option>
                                <el-option label="月" value="month"></el-option>
                                <el-option label="年" value="year"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-input>
                </el-form-item>
                <el-form-item label="原始价格" prop="old_price">
                    <el-input v-model.trim="formData.old_price" maxlength="20" show-word-limit style="width:300px;">
                        <template slot="append">元</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="价格" prop="price">
                    <el-input v-model.trim="formData.price" maxlength="20" show-word-limit style="width:300px;">
                        <template slot="append">元</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="说明" prop="des">
                    <el-input v-model="formData.des" maxlength="100" show-word-limit style="width:300px;"></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                    <el-input v-model="formData.sort" maxlength="20" show-word-limit style="width:300px;"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="state">
                    <el-switch
                            v-model="formData.state"
                            active-color="#13ce66"
                            active-value="1"
                            inactive-value="0"
                            active-text="启用"
                            inactive-text="禁用">
                    </el-switch>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('form')">确定</el-button>
                    <el-button type="" @click="$router.back()">返回</el-button>
                </el-form-item>
            </el-form>
        </div>
    </m-main-layout>
</template>

<script>
	export default {
		name: "GoodsSpecAdd",
		data() {
			return {
				formData: {
					id:'',
					vip_id:'',
					title:'',
					state:'1',
					to_time:1,
					time_type:'',
					sort:0,
					price:0,
                    des:'',
					price_level:0,
                    old_price:0
				},
				rules: {
					title: [
						{ required: true},
					],
					state: [
						{ required: true},
					],
					vip_id: [
						{ required: true},
					],
					time_type: [
						{ required: true},
					],
					sort: [
						{ required: true},
					],
					// des: [
					// 	{ required: true},
					// ],
					price_level:[{required:true,validator: this.$utils.mustNumber}],
					to_time: [
						{ required: true,validator: this.$utils.mustNumber},
					],
					price: [
						{ required: true,validator: this.$utils.rulePriceNotZero},
					],
					old_price: [
						{ required: true,validator: this.$utils.rulePriceCanZero},
					],
				},
			};
		},
		created(){
			this.formData.id = this.$route.params.id ? this.$route.params.id : 0;
		},
        mounted(){
	        if(this.formData.id !== 0){
		        this.getDetail();
	        }
        },
		methods: {
			submitForm(formName) {
				let _this = this;
				this.$refs[formName].validate((valid) => {
					if (valid) {
						console.log(_this.formData);
						_this.$http.httpPost({
							url:'VipPrice/edit',
							datas:_this.formData,
							success:(res)=>{
								_this.$router.replace({path: '/user/vip/price/list',query:{vip_id:_this.formData.vip_id}})
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			getDetail(){
				let _this = this;

				_this.$http.httpPost({
					url:'VipPrice/detail',
					datas:{id:_this.formData.id},
					success:(res)=>{
						// console.log(res);

                        _this.formData.vip_id = res.vip_id;
						_this.formData.title = res.title;
						_this.formData.sort = res.sort;
						_this.formData.to_time = res.to_time;
						_this.formData.time_type = res.time_type;
						_this.formData.price = res.price;
						_this.formData.old_price = res.old_price;
						_this.formData.state = res.state.toString();
						_this.formData.des = res.des;
						_this.formData.price_level = res.price_level;
					}
				})
			}
		}
	}
</script>
<style>
    .el-select .el-input {
        width: 150px;
    }
    .input-with-select .el-input-group__append {
        background-color: #fff;
    }
</style>
